/**
 * @generated SignedSource<<f6d7c68d9c3b10796cebfd31e5f845a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpecialPage = "ASSET_VISITOR_INFO" | "PUBLICATIONS_VISITOR_INFO" | "VISITOR_INFO" | "%future added value";
export type VisitorInfo = {
  code: string;
  country?: string | null | undefined;
};
export type SiteQueryContainerQuery$variables = {
  language: string;
  path: string;
  salesAdmission: string;
  searchString?: string | null | undefined;
  specialPageId: SpecialPage;
  visitorInfo?: VisitorInfo | null | undefined;
};
export type SiteQueryContainerQuery$data = {
  readonly site: {
    readonly " $fragmentSpreads": FragmentRefs<"Site_site">;
  } | null | undefined;
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"Site_user">;
  } | null | undefined;
};
export type SiteQueryContainerQuery = {
  response: SiteQueryContainerQuery$data;
  variables: SiteQueryContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "path"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesAdmission"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "specialPageId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "visitorInfo"
},
v6 = {
  "kind": "Variable",
  "name": "language",
  "variableName": "language"
},
v7 = {
  "kind": "Variable",
  "name": "path",
  "variableName": "path"
},
v8 = {
  "kind": "Variable",
  "name": "salesAdmission",
  "variableName": "salesAdmission"
},
v9 = {
  "kind": "Variable",
  "name": "searchString",
  "variableName": "searchString"
},
v10 = {
  "kind": "Variable",
  "name": "visitorInfo",
  "variableName": "visitorInfo"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pageTitle",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUrl",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Breadcrumb",
  "kind": "LinkedField",
  "name": "breadcrumbs",
  "plural": true,
  "selections": [
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "link",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v20 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v21 = {
  "alias": "archiveTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "yearLabel",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placeholder",
  "storageKey": null
},
v24 = [
  (v23/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveFilter",
  "kind": "LinkedField",
  "name": "livefilter",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "col",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryname",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "CategoryInfo",
  "kind": "LinkedField",
  "name": "info",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CategoryInfoEntry",
      "kind": "LinkedField",
      "name": "entries",
      "plural": true,
      "selections": [
        (v13/*: any*/),
        (v28/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = [
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "filtervalue",
    "storageKey": null
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v32 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SelectBoxItem",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      (v31/*: any*/),
      (v13/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "SelectBox",
  "kind": "LinkedField",
  "name": "selectbox",
  "plural": false,
  "selections": (v32/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "filtercategory",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v26/*: any*/),
        (v27/*: any*/),
        (v29/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailFilterItem",
          "kind": "LinkedField",
          "name": "filteritems",
          "plural": true,
          "selections": (v30/*: any*/),
          "storageKey": null
        }
      ],
      "type": "DetailFilterListCategory",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v26/*: any*/),
        (v27/*: any*/),
        (v29/*: any*/),
        (v33/*: any*/)
      ],
      "type": "DetailFilterDropdownCategory",
      "abstractKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resetText",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resultTextSingular",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resultTextPlural",
  "storageKey": null
},
v38 = [
  (v34/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "DetailFilterSelectionInfo",
    "kind": "LinkedField",
    "name": "selectioninfo",
    "plural": false,
    "selections": [
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/)
    ],
    "storageKey": null
  },
  (v11/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "DetailFilter",
  "kind": "LinkedField",
  "name": "detailfilter",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "header",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "format",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "ArchiveFileLink",
  "kind": "LinkedField",
  "name": "documents",
  "plural": true,
  "selections": [
    (v40/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "doctypeheader",
      "storageKey": null
    },
    (v41/*: any*/),
    (v42/*: any*/),
    (v14/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noresultstext",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterbuttontext",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterbuttontextexpanded",
  "storageKey": null
},
v49 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    (v22/*: any*/),
    (v25/*: any*/),
    (v39/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/)
  ],
  "type": "ArchiveList",
  "abstractKey": null
},
v50 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "info",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "indent",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueInfo",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v55 = [
  (v8/*: any*/)
],
v56 = [
  (v41/*: any*/),
  (v42/*: any*/),
  (v14/*: any*/),
  (v40/*: any*/),
  (v43/*: any*/),
  (v44/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "smallicon",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "largeicon",
    "storageKey": null
  }
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disclaimer",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longtext",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v63 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "managername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "managercompany",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "advisortext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfilePicture",
      "kind": "LinkedField",
      "name": "picture",
      "plural": false,
      "selections": [
        (v14/*: any*/)
      ],
      "storageKey": null
    },
    (v61/*: any*/),
    (v62/*: any*/)
  ],
  "type": "FundsManager",
  "abstractKey": null
},
v64 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompositionChartData",
      "kind": "LinkedField",
      "name": "data",
      "plural": true,
      "selections": [
        (v60/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v57/*: any*/)
  ],
  "type": "CompositionChart",
  "abstractKey": null
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": (v50/*: any*/),
      "concreteType": "ItemListEntryConnection",
      "kind": "LinkedField",
      "name": "entries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemListEntryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemListEntry",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v13/*: any*/),
                (v28/*: any*/),
                (v51/*: any*/),
                (v52/*: any*/),
                (v53/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "entries(first:1000)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smalllabel",
      "storageKey": null
    }
  ],
  "type": "ItemList",
  "abstractKey": null
},
v66 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FileLink",
    "kind": "LinkedField",
    "name": "brochure",
    "plural": false,
    "selections": (v56/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "FileLink",
    "kind": "LinkedField",
    "name": "factsheet",
    "plural": false,
    "selections": (v56/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "FileLink",
    "kind": "LinkedField",
    "name": "kid",
    "plural": false,
    "selections": (v56/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "FileLink",
    "kind": "LinkedField",
    "name": "others",
    "plural": true,
    "selections": (v56/*: any*/),
    "storageKey": null
  }
],
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "InfoLink",
  "kind": "LinkedField",
  "name": "infolinks",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    (v41/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "infotext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linktext",
      "storageKey": null
    },
    (v31/*: any*/)
  ],
  "storageKey": null
},
v68 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ComponentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v16/*: any*/),
          (v63/*: any*/),
          (v64/*: any*/),
          (v65/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v55/*: any*/),
                "concreteType": "RecentTrancheDocuments",
                "kind": "LinkedField",
                "name": "files",
                "plural": false,
                "selections": (v66/*: any*/),
                "storageKey": null
              },
              (v67/*: any*/)
            ],
            "type": "Documents",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largeinvestmentfonds",
  "storageKey": null
},
v70 = [
  (v26/*: any*/),
  (v13/*: any*/)
],
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "TableHeader",
  "kind": "LinkedField",
  "name": "tableheader",
  "plural": true,
  "selections": (v70/*: any*/),
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fundsname",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "distribution",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "traits",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isin",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "institutional",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesadmission",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noResultsMessage",
  "storageKey": null
},
v81 = [
  (v13/*: any*/),
  (v14/*: any*/)
],
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "SimpleLink",
  "kind": "LinkedField",
  "name": "downloadOverview",
  "plural": false,
  "selections": (v81/*: any*/),
  "storageKey": null
},
v83 = [
  (v13/*: any*/),
  (v33/*: any*/)
],
v84 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "all",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "kid",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "factsheet",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publications",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rb",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hjb",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "taxtreat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fpp",
    "storageKey": null
  },
  (v51/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "prospect",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "generalpublications",
    "storageKey": null
  }
],
v85 = [
  (v16/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v58/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "TaglineLink",
        "kind": "LinkedField",
        "name": "links",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tagline",
            "storageKey": null
          },
          (v42/*: any*/),
          (v58/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "LinkGroup",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v58/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "LinkList",
        "kind": "LinkedField",
        "name": "linkLists",
        "plural": true,
        "selections": [
          (v58/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IconLink",
            "kind": "LinkedField",
            "name": "links",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v15/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "LinkListGroup",
    "abstractKey": null
  }
],
v86 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 4
  }
],
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fundsListUrl",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "required",
  "storageKey": null
},
v90 = {
  "kind": "InlineFragment",
  "selections": [
    (v60/*: any*/),
    (v13/*: any*/),
    (v89/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "special",
      "storageKey": null
    }
  ],
  "type": "SingleLineText",
  "abstractKey": null
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    (v60/*: any*/),
    (v13/*: any*/),
    (v89/*: any*/)
  ],
  "type": "MultiLineText",
  "abstractKey": null
},
v92 = {
  "kind": "InlineFragment",
  "selections": [
    (v60/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RadioOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v28/*: any*/),
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "attached",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            (v90/*: any*/),
            (v91/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v89/*: any*/)
  ],
  "type": "RadioGroup",
  "abstractKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noResultsText",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confirmLabel",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "VisitorCountryChoice",
  "kind": "LinkedField",
  "name": "country",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VisitorCountryOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v95/*: any*/),
        (v13/*: any*/)
      ],
      "storageKey": null
    },
    (v58/*: any*/)
  ],
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "concreteType": "VisitorTypeChoice",
  "kind": "LinkedField",
  "name": "visitorType",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VisitorTypeOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v95/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        (v13/*: any*/)
      ],
      "storageKey": null
    },
    (v58/*: any*/)
  ],
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "explanation",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectedTitle",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectedText",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectedButtonLabel",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectLabel",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SiteQueryContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          {
            "args": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "kind": "Variable",
                "name": "specialPageId",
                "variableName": "specialPageId"
              },
              (v10/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "Site_site"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserContainer",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Site_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "FundServiceQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "SiteQueryContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v7/*: any*/),
              (v10/*: any*/)
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageHeader",
                "kind": "LinkedField",
                "name": "header",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pageImageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pageBackgroundImageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "smallHeader",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pageImageOverlayText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IconLink",
                    "kind": "LinkedField",
                    "name": "authLink",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isPage"
              },
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Translation",
                "kind": "LinkedField",
                "name": "translations",
                "plural": true,
                "selections": [
                  (v19/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v20/*: any*/),
                    "concreteType": "ComponentConnection",
                    "kind": "LinkedField",
                    "name": "components",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v16/*: any*/),
                              (v49/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v41/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v50/*: any*/),
                                    "concreteType": "ComponentConnection",
                                    "kind": "LinkedField",
                                    "name": "entries",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ComponentEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v16/*: any*/),
                                              (v11/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  (v13/*: any*/),
                                                  (v51/*: any*/),
                                                  (v52/*: any*/),
                                                  (v53/*: any*/)
                                                ],
                                                "type": "ItemListEntry",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "entries(first:1000)"
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BaseDataEquity",
                                    "kind": "LinkedField",
                                    "name": "equity",
                                    "plural": false,
                                    "selections": [
                                      (v54/*: any*/),
                                      (v28/*: any*/),
                                      (v42/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "datetext",
                                        "storageKey": null
                                      },
                                      (v40/*: any*/),
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v55/*: any*/),
                                    "concreteType": "FileLink",
                                    "kind": "LinkedField",
                                    "name": "files",
                                    "plural": true,
                                    "selections": (v56/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BaseDataChart",
                                    "kind": "LinkedField",
                                    "name": "chart",
                                    "plural": false,
                                    "selections": [
                                      (v42/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "level",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "levelmax",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "leveltext1",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "leveltext2",
                                        "storageKey": null
                                      },
                                      (v51/*: any*/),
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "BaseData",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v41/*: any*/),
                                  (v57/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "staticDisclaimer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PerformanceOverviewInfo",
                                    "kind": "LinkedField",
                                    "name": "info",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "currentperformancetext",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "currentbenchmarktext",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "paperformancetext",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "pabenchmarktext",
                                        "storageKey": null
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PerformanceOverviewMenu",
                                    "kind": "LinkedField",
                                    "name": "menu",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "currencySelectionSaveButtonText",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "currencySelectionInfo",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "currencySelectionHeader",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "xlsdownloadtext",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SelectBox",
                                        "kind": "LinkedField",
                                        "name": "currencySelectBox",
                                        "plural": false,
                                        "selections": (v32/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "PerformanceOverview",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "performanceTitle",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PerformanceByYearLineItem",
                                    "kind": "LinkedField",
                                    "name": "lineItems",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "period",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "development",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "PerformanceByYear",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v58/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "shorttext",
                                    "storageKey": null
                                  },
                                  (v59/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "warning",
                                    "storageKey": null
                                  }
                                ],
                                "type": "FundsIntroduction",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LabeledSelectBox",
                                    "kind": "LinkedField",
                                    "name": "tranches",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v33/*: any*/),
                                      {
                                        "alias": "trancheSelectBox",
                                        "args": null,
                                        "concreteType": "SelectBox",
                                        "kind": "LinkedField",
                                        "name": "selectbox",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SelectBoxItem",
                                            "kind": "LinkedField",
                                            "name": "options",
                                            "plural": true,
                                            "selections": [
                                              (v31/*: any*/),
                                              (v13/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TrancheSelection",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v41/*: any*/),
                                  (v60/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v20/*: any*/),
                                    "concreteType": "ComponentConnection",
                                    "kind": "LinkedField",
                                    "name": "components",
                                    "plural": false,
                                    "selections": (v68/*: any*/),
                                    "storageKey": "components(first:10000)"
                                  }
                                ],
                                "type": "Widget",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "components(first:10000)"
                  },
                  (v69/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reportcurrency",
                    "storageKey": null
                  }
                ],
                "type": "FundsDetailsPage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v50/*: any*/),
                    "concreteType": "ComponentConnection",
                    "kind": "LinkedField",
                    "name": "components",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v58/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FundsTable",
                                    "kind": "LinkedField",
                                    "name": "fundstable",
                                    "plural": false,
                                    "selections": [
                                      (v71/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v50/*: any*/),
                                        "concreteType": "FundsConnection",
                                        "kind": "LinkedField",
                                        "name": "entries",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FundsEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Funds",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v11/*: any*/),
                                                  (v72/*: any*/),
                                                  (v73/*: any*/),
                                                  (v74/*: any*/),
                                                  (v54/*: any*/),
                                                  (v75/*: any*/),
                                                  (v76/*: any*/),
                                                  (v69/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": (v50/*: any*/),
                                                    "concreteType": "TrancheConnection",
                                                    "kind": "LinkedField",
                                                    "name": "tranches",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "TrancheEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Tranche",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v14/*: any*/),
                                                              (v54/*: any*/),
                                                              (v74/*: any*/),
                                                              (v11/*: any*/),
                                                              (v77/*: any*/),
                                                              (v78/*: any*/),
                                                              (v79/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": "tranches(first:1000)"
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "entries(first:1000)"
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DetailFilter",
                                        "kind": "LinkedField",
                                        "name": "detailfilter",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DetailFilterSelectionInfo",
                                            "kind": "LinkedField",
                                            "name": "selectioninfo",
                                            "plural": false,
                                            "selections": [
                                              (v36/*: any*/),
                                              (v37/*: any*/),
                                              (v35/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v34/*: any*/),
                                          (v11/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v25/*: any*/),
                                      (v47/*: any*/),
                                      (v48/*: any*/),
                                      (v80/*: any*/),
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v82/*: any*/)
                                ],
                                "type": "FundsSelection",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v41/*: any*/),
                                  (v60/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v50/*: any*/),
                                    "concreteType": "ComponentConnection",
                                    "kind": "LinkedField",
                                    "name": "components",
                                    "plural": false,
                                    "selections": (v68/*: any*/),
                                    "storageKey": "components(first:1000)"
                                  }
                                ],
                                "type": "Widget",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "components(first:1000)"
                  }
                ],
                "type": "FundsListPage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabeledSelectBox",
                    "kind": "LinkedField",
                    "name": "salesadmission",
                    "plural": false,
                    "selections": (v83/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabeledSelectBox",
                    "kind": "LinkedField",
                    "name": "retailOnly",
                    "plural": false,
                    "selections": (v83/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v50/*: any*/),
                    "concreteType": "ComponentConnection",
                    "kind": "LinkedField",
                    "name": "components",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v58/*: any*/),
                                  (v59/*: any*/)
                                ],
                                "type": "SubscriptionIntroduction",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "retailOnly",
                                        "value": true
                                      },
                                      (v8/*: any*/)
                                    ],
                                    "concreteType": "SubscriptionTable",
                                    "kind": "LinkedField",
                                    "name": "subscriptiontable",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v71/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DocumentsSubscribed",
                                        "kind": "LinkedField",
                                        "name": "documentheaders",
                                        "plural": false,
                                        "selections": (v84/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SubscriptionTranche",
                                        "kind": "LinkedField",
                                        "name": "entries",
                                        "plural": true,
                                        "selections": [
                                          (v11/*: any*/),
                                          (v72/*: any*/),
                                          (v77/*: any*/),
                                          (v73/*: any*/),
                                          (v54/*: any*/),
                                          (v79/*: any*/),
                                          (v74/*: any*/),
                                          (v78/*: any*/),
                                          (v76/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DocumentsSubscribed",
                                            "kind": "LinkedField",
                                            "name": "documents",
                                            "plural": false,
                                            "selections": (v84/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DocumentLabels",
                                        "kind": "LinkedField",
                                        "name": "documentlabels",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DocumentLabel",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": true,
                                            "selections": [
                                              (v31/*: any*/),
                                              (v13/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "shortlabel",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "documentLabelsTitle",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "furtherDocumentLabelsTitle",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "allDocumentLabelsTitle",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v25/*: any*/),
                                      (v39/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DetailFilter",
                                        "kind": "LinkedField",
                                        "name": "subscriptionfilter",
                                        "plural": false,
                                        "selections": (v38/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LanguagePreference",
                                        "kind": "LinkedField",
                                        "name": "languagepreference",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "currentselection",
                                            "storageKey": null
                                          },
                                          (v29/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DetailFilterItem",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": (v30/*: any*/),
                                            "storageKey": null
                                          },
                                          (v27/*: any*/),
                                          (v11/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v47/*: any*/),
                                      (v48/*: any*/),
                                      (v80/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v55/*: any*/),
                                    "concreteType": "PriceInfo",
                                    "kind": "LinkedField",
                                    "name": "priceinfo",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "checked",
                                        "storageKey": null
                                      },
                                      (v71/*: any*/),
                                      (v58/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FileLink",
                                        "kind": "LinkedField",
                                        "name": "file",
                                        "plural": false,
                                        "selections": (v56/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SimpleLink",
                                        "kind": "LinkedField",
                                        "name": "archive",
                                        "plural": false,
                                        "selections": (v81/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "changesbuttontext",
                                    "storageKey": null
                                  }
                                ],
                                "type": "SubscriptionManager",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "components(first:1000)"
                  }
                ],
                "type": "InfoServicePage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v50/*: any*/),
                    "concreteType": "ComponentConnection",
                    "kind": "LinkedField",
                    "name": "components",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v49/*: any*/),
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "components(first:1000)"
                  }
                ],
                "type": "SimplePage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v55/*: any*/),
                    "concreteType": "ArchiveList",
                    "kind": "LinkedField",
                    "name": "archive",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v25/*: any*/),
                      (v39/*: any*/),
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "ArchivePage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v20/*: any*/),
                    "concreteType": "ComponentConnection",
                    "kind": "LinkedField",
                    "name": "components",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v58/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "introduction",
                                    "storageKey": null
                                  },
                                  (v57/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CutOffTable",
                                    "kind": "LinkedField",
                                    "name": "cutOffTable",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": (v50/*: any*/),
                                        "concreteType": "CoTrancheConnection",
                                        "kind": "LinkedField",
                                        "name": "entries",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CoTrancheEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CoTranche",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v11/*: any*/),
                                                  (v60/*: any*/),
                                                  (v77/*: any*/),
                                                  (v54/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "frequency",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "frequencyComment",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "cutOffTime",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "valueDate",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "salesAdmission",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "entries(first:1000)"
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TableHeader",
                                        "kind": "LinkedField",
                                        "name": "tableHeader",
                                        "plural": true,
                                        "selections": (v70/*: any*/),
                                        "storageKey": null
                                      },
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LabeledSelectBox",
                                    "kind": "LinkedField",
                                    "name": "salesAdmission",
                                    "plural": false,
                                    "selections": (v83/*: any*/),
                                    "storageKey": null
                                  },
                                  (v82/*: any*/)
                                ],
                                "type": "CutOffList",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v41/*: any*/),
                                  (v60/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v50/*: any*/),
                                    "concreteType": "ComponentConnection",
                                    "kind": "LinkedField",
                                    "name": "components",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ComponentEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              (v16/*: any*/),
                                              (v63/*: any*/),
                                              (v64/*: any*/),
                                              (v65/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "salesAdmission",
                                                        "value": "AT"
                                                      }
                                                    ],
                                                    "concreteType": "RecentTrancheDocuments",
                                                    "kind": "LinkedField",
                                                    "name": "files",
                                                    "plural": false,
                                                    "selections": (v66/*: any*/),
                                                    "storageKey": "files(salesAdmission:\"AT\")"
                                                  },
                                                  (v67/*: any*/)
                                                ],
                                                "type": "Documents",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "components(first:1000)"
                                  }
                                ],
                                "type": "Widget",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "components(first:10000)"
                  }
                ],
                "type": "CutOffPage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "firstGroup",
                    "plural": false,
                    "selections": (v85/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "secondGroup",
                    "plural": false,
                    "selections": (v85/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "thirdGroup",
                    "plural": false,
                    "selections": (v85/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "FrontPage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v58/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SiblingNavigation",
                    "kind": "LinkedField",
                    "name": "siblingNavigation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SimpleLink",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "blocks",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "awardsTitle",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v86/*: any*/),
                            "concreteType": "AwardsListItem_bang_Connection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasPreviousPage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "startCursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AwardsListItem_bang_Edge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AwardsListItem",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "year",
                                        "storageKey": null
                                      },
                                      (v87/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "awardName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "awardText",
                                        "storageKey": null
                                      },
                                      (v16/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "items(last:4)"
                          },
                          {
                            "alias": null,
                            "args": (v86/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "AwardsListBlock_items",
                            "kind": "LinkedHandle",
                            "name": "items"
                          }
                        ],
                        "type": "AwardsList",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "phoneLabel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "faxLabel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emailLabel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "address",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "companyName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "street",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "postCode",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "city",
                                "storageKey": null
                              },
                              (v75/*: any*/),
                              (v61/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fax",
                                "storageKey": null
                              },
                              (v62/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Coordinates",
                            "kind": "LinkedField",
                            "name": "coordinates",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latitude",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "longitude",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LocationBlock",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/)
                        ],
                        "type": "AbstractBlock",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v87/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "logoAltText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "captionTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "captionText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isQuote",
                            "storageKey": null
                          }
                        ],
                        "type": "LogoBlock",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markdown",
                            "storageKey": null
                          }
                        ],
                        "type": "MarkdownBlock",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v58/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "altText",
                            "storageKey": null
                          }
                        ],
                        "type": "PictureBlock",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "author",
                            "storageKey": null
                          },
                          (v15/*: any*/)
                        ],
                        "type": "QuoteBlock",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v58/*: any*/),
                          (v42/*: any*/)
                        ],
                        "type": "TextBlock",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "ContentPage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "sections",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "anchorName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "navigationTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "titleImageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "titleImageBackgroundUrl",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v58/*: any*/),
                          {
                            "alias": "linkSectionText",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ComplexLink",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": true,
                            "selections": [
                              (v58/*: any*/),
                              (v42/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LinkSection",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v58/*: any*/),
                          {
                            "alias": "overviewSectionText",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SimpleLink",
                            "kind": "LinkedField",
                            "name": "detailPageLink",
                            "plural": false,
                            "selections": (v81/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "OverviewSection",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v58/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HomeFundIntroductionForCountry",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": true,
                            "selections": [
                              (v75/*: any*/),
                              (v42/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subTitle",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subText",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quote",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SimpleLink",
                                "kind": "LinkedField",
                                "name": "link1",
                                "plural": false,
                                "selections": (v81/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SimpleLink",
                                "kind": "LinkedField",
                                "name": "link2",
                                "plural": false,
                                "selections": (v81/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "HomeFundIntroduction",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v58/*: any*/),
                          (v88/*: any*/),
                          (v42/*: any*/),
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showAll",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "show",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HomeFundServiceAutocomplete",
                            "kind": "LinkedField",
                            "name": "autocomplete",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v50/*: any*/),
                                "concreteType": "FundsConnection",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FundsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Funds",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v75/*: any*/),
                                          (v72/*: any*/),
                                          (v69/*: any*/),
                                          {
                                            "alias": null,
                                            "args": (v50/*: any*/),
                                            "concreteType": "TrancheConnection",
                                            "kind": "LinkedField",
                                            "name": "tranches",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TrancheEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Tranche",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v14/*: any*/),
                                                      (v77/*: any*/),
                                                      (v79/*: any*/),
                                                      (v11/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "tranches(first:1000)"
                                          },
                                          (v11/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "items(first:1000)"
                              },
                              (v80/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "furtherResultsMessage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "HomeFundService",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v58/*: any*/),
                          (v42/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "loginLink",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "registrationLink",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "loginText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "registrationText",
                            "storageKey": null
                          }
                        ],
                        "type": "HomeFundInfoservice",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "SectionPage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v58/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactForm",
                    "kind": "LinkedField",
                    "name": "form",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/),
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formItems",
                        "plural": true,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v58/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  (v16/*: any*/),
                                  (v92/*: any*/),
                                  (v90/*: any*/),
                                  (v91/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "FormItemGroup",
                            "abstractKey": null
                          },
                          (v92/*: any*/),
                          (v90/*: any*/),
                          (v91/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "submitButtonLabel",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "ContactPage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v93/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resultsTextSingular",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resultsTextPlural",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      (v9/*: any*/)
                    ],
                    "concreteType": "SearchResult",
                    "kind": "LinkedField",
                    "name": "results",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headline",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "snippet",
                        "storageKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v58/*: any*/)
                ],
                "type": "SearchPage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v94/*: any*/),
                  (v96/*: any*/),
                  (v97/*: any*/),
                  (v57/*: any*/),
                  (v98/*: any*/),
                  (v19/*: any*/),
                  (v60/*: any*/),
                  (v99/*: any*/),
                  (v100/*: any*/),
                  (v101/*: any*/),
                  (v102/*: any*/)
                ],
                "type": "VisitorInfoPage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PublicationsList",
                    "kind": "LinkedField",
                    "name": "publicationsList",
                    "plural": false,
                    "selections": [
                      (v58/*: any*/),
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "filterButtonText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "filterButtonTextExpanded",
                        "storageKey": null
                      },
                      (v93/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "variousFundsText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LiveFilter",
                        "kind": "LinkedField",
                        "name": "liveFilter",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DetailFilter",
                        "kind": "LinkedField",
                        "name": "detailFilter",
                        "plural": false,
                        "selections": (v38/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PublicationDocument",
                        "kind": "LinkedField",
                        "name": "documents",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "archiveName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mimeType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fileDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "docTypeName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "documentType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "documentTitle",
                            "storageKey": null
                          },
                          (v44/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fileName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deeplinkCode",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fundName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isins",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "PublicationsPage",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userCountry",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v7/*: any*/)
            ],
            "concreteType": "SiteInfo",
            "kind": "LinkedField",
            "name": "siteInfo",
            "plural": false,
            "selections": [
              (v88/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rootUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SimpleLink",
                "kind": "LinkedField",
                "name": "navigation",
                "plural": true,
                "selections": (v81/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "searchPageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SimpleLink",
                "kind": "LinkedField",
                "name": "footer",
                "plural": true,
                "selections": (v81/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v6/*: any*/),
              {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "specialPageId"
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "specialPage",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v11/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v18/*: any*/),
                  (v94/*: any*/),
                  (v96/*: any*/),
                  (v97/*: any*/),
                  (v17/*: any*/),
                  (v57/*: any*/),
                  (v98/*: any*/),
                  (v19/*: any*/),
                  (v60/*: any*/),
                  (v12/*: any*/),
                  (v99/*: any*/),
                  (v100/*: any*/),
                  (v101/*: any*/),
                  (v102/*: any*/)
                ],
                "type": "VisitorInfoPage",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserContainer",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLoggedIn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "110c9fb4812f0fb20e2d9fb3b8de8534",
    "id": null,
    "metadata": {},
    "name": "SiteQueryContainerQuery",
    "operationKind": "query",
    "text": "query SiteQueryContainerQuery(\n  $path: String!\n  $visitorInfo: VisitorInfo\n  $language: String!\n  $salesAdmission: String!\n  $searchString: String\n  $specialPageId: SpecialPage!\n) {\n  site {\n    ...Site_site_2XmeMr\n    id\n  }\n  user {\n    ...Site_user\n  }\n}\n\nfragment AboHeader_header on SubscriptionTable {\n  tableheader {\n    col\n    label\n  }\n}\n\nfragment AboManager_component_6AafZ on SubscriptionManager {\n  id\n  subscriptiontable(salesAdmission: $salesAdmission, retailOnly: true) {\n    id\n    ...AboTable_table\n  }\n  priceinfo(salesAdmission: $salesAdmission) {\n    id\n    checked\n    ...PriceInfo_component\n  }\n  changesbuttontext\n}\n\nfragment AboTable_table on SubscriptionTable {\n  ...AboHeader_header\n  documentheaders {\n    all\n    kid\n    factsheet\n    publications\n    rb\n    hjb\n    taxtreat\n    fpp\n    info\n    prospect\n    generalpublications\n  }\n  entries {\n    id\n    fundsname\n    isin\n    category\n    currency\n    salesadmission\n    distribution\n    institutional\n    traits\n    documents {\n      all\n      kid\n      factsheet\n      publications\n      rb\n      hjb\n      taxtreat\n      fpp\n      info\n      prospect\n      generalpublications\n    }\n  }\n  documentlabels {\n    labels {\n      key\n    }\n    documentLabelsTitle\n    ...OtherDocuments_documentLabels\n  }\n  livefilter {\n    ...LiveFilter_liveFilter\n  }\n  detailfilter {\n    ...DetailFilter_detailFilter\n    id\n  }\n  subscriptionfilter {\n    ...DetailFilter_detailFilter\n    id\n  }\n  languagepreference {\n    currentselection\n    ...LanguagePreference_component\n    id\n  }\n  filterbuttontext\n  filterbuttontextexpanded\n  noResultsMessage\n}\n\nfragment AbstractBlock_contentBlock on AbstractBlock {\n  text\n}\n\nfragment Address_address on Address {\n  companyName\n  street\n  postCode\n  city\n  country\n  phone\n  fax\n  email\n}\n\nfragment ArchiveFileLink_archiveFileLink on ArchiveFileLink {\n  date\n  doctypeheader\n  header\n  text\n  url\n  format\n  size\n  icon\n}\n\nfragment ArchiveList_component on ArchiveList {\n  archiveTitle: title\n  yearLabel\n  livefilter {\n    ...LiveFilter_liveFilter\n  }\n  detailfilter {\n    ...DetailFilter_detailFilter\n    id\n  }\n  documents {\n    ...ArchiveFileLink_archiveFileLink\n    date\n    doctypeheader\n    header\n    text\n  }\n  noresultstext\n  filterbuttontext\n  filterbuttontextexpanded\n}\n\nfragment ArchivePage_page_2QtZrJ on ArchivePage {\n  archive(salesAdmission: $salesAdmission) {\n    ...ArchiveList_component\n    id\n  }\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n  path\n  id\n}\n\nfragment AuthButton_authLink on IconLink {\n  label\n  url\n  iconUrl\n}\n\nfragment AwardsListBlock_contentBlock on AwardsList {\n  id\n  awardsTitle: title\n  items(last: 4) {\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n    edges {\n      node {\n        year\n        ...AwardsListItem_awardsListItem\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment AwardsListItem_awardsListItem on AwardsListItem {\n  year\n  logoUrl\n  awardName\n  awardText\n}\n\nfragment BaseDataChart_chart on BaseDataChart {\n  text\n  level\n  levelmax\n  leveltext1\n  leveltext2\n  info\n}\n\nfragment BaseDataEquity_content on BaseDataEquity {\n  currency\n  value\n  text\n  datetext\n  date\n}\n\nfragment BaseData_component_2QtZrJ on BaseData {\n  header\n  entries(first: 1000) {\n    edges {\n      node {\n        __typename\n        ... on ItemListEntry {\n          value\n        }\n        ...ItemListEntry_component\n        id\n      }\n    }\n  }\n  equity {\n    ...BaseDataEquity_content\n    id\n  }\n  files(salesAdmission: $salesAdmission) {\n    ...FileLink_fileLink\n  }\n  chart {\n    ...BaseDataChart_chart\n    id\n  }\n}\n\nfragment Breadcrumb_data on Breadcrumb {\n  label\n  link\n}\n\nfragment CategoryInfoEntry_entry on CategoryInfoEntry {\n  label\n  value\n}\n\nfragment CategoryInfo_info on CategoryInfo {\n  entries {\n    ...CategoryInfoEntry_entry\n  }\n}\n\nfragment ComplexLink_complexLink on ComplexLink {\n  title\n  text\n  url\n}\n\nfragment CompositionChart_component on CompositionChart {\n  data {\n    name\n    percent\n    color\n  }\n  disclaimer\n}\n\nfragment ContactForm_contactForm on ContactForm {\n  header\n  text\n  formItems {\n    __typename\n    ... on FormItemGroup {\n      title\n      items {\n        __typename\n        ... on RadioGroup {\n          name\n          options {\n            value\n            label\n            attached {\n              __typename\n              ... on SingleLineText {\n                name\n                label\n                required\n                special\n              }\n              ... on MultiLineText {\n                name\n                label\n                required\n              }\n            }\n          }\n          required\n        }\n        ... on SingleLineText {\n          name\n          label\n          required\n          special\n        }\n        ... on MultiLineText {\n          name\n          label\n          required\n        }\n      }\n    }\n    ... on RadioGroup {\n      name\n      options {\n        value\n        label\n        attached {\n          __typename\n          ... on SingleLineText {\n            name\n            label\n            required\n            special\n          }\n          ... on MultiLineText {\n            name\n            label\n            required\n          }\n        }\n      }\n      required\n    }\n    ... on SingleLineText {\n      name\n      label\n      required\n      special\n    }\n    ... on MultiLineText {\n      name\n      label\n      required\n    }\n  }\n  submitButtonLabel\n}\n\nfragment ContactPage_page on ContactPage {\n  path\n  id\n  breadcrumbs {\n    label\n    ...Breadcrumb_data\n  }\n  title\n  form {\n    ...ContactForm_contactForm\n  }\n}\n\nfragment ContentPage_page on ContentPage {\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n  __typename\n  title\n  siblingNavigation {\n    ...SiblingNavigation_siblingNavigation\n  }\n  blocks {\n    __typename\n    ...AwardsListBlock_contentBlock\n    ...LocationBlock_contentBlock\n    ...AbstractBlock_contentBlock\n    ...LogoBlock_contentBlock\n    ...MarkdownBlock_contentBlock\n    ...PictureBlock_contentBlock\n    ...QuoteBlock_contentBlock\n    ...TextBlock_contentBlock\n    id\n  }\n}\n\nfragment CutOffListDownload_cutOffListDownload on SimpleLink {\n  label\n  url\n}\n\nfragment CutOffListPage_page on CutOffPage {\n  components(first: 10000) {\n    edges {\n      node {\n        __typename\n        ...CutOffList_component\n        ...Widget_component_1W07gZ\n        id\n      }\n    }\n  }\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n  path\n  id\n}\n\nfragment CutOffList_component on CutOffList {\n  title\n  introduction\n  disclaimer\n  cutOffTable {\n    ...CutOffTable_table\n    id\n  }\n  salesAdmission {\n    ...LabeledSelectBox_labeledSelectBox\n  }\n  downloadOverview {\n    ...CutOffListDownload_cutOffListDownload\n  }\n}\n\nfragment CutOffTableHeader_header on CutOffTable {\n  tableHeader {\n    col\n    label\n  }\n}\n\nfragment CutOffTable_table on CutOffTable {\n  entries(first: 1000) {\n    edges {\n      node {\n        id\n        name\n        isin\n        currency\n        frequency\n        frequencyComment\n        cutOffTime\n        valueDate\n        salesAdmission\n      }\n    }\n  }\n  ...CutOffTableHeader_header\n}\n\nfragment DeniedPage_page on Page {\n  __isPage: __typename\n  id\n  path\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n}\n\nfragment DetailFilterDropdownCategory_category on DetailFilterDropdownCategory {\n  col\n  categoryname\n  info {\n    ...CategoryInfo_info\n  }\n  selectbox {\n    ...Selectbox_selectBox\n  }\n}\n\nfragment DetailFilterListCategory_category on DetailFilterListCategory {\n  col\n  categoryname\n  info {\n    ...CategoryInfo_info\n  }\n  filteritems {\n    label\n    filtervalue\n  }\n}\n\nfragment DetailFilterSelectionInfo_selectionInfo on DetailFilterSelectionInfo {\n  resetText\n  resultTextSingular\n  resultTextPlural\n}\n\nfragment DetailFilter_detailFilter on DetailFilter {\n  filtercategory {\n    __typename\n    ... on DetailFilterListCategory {\n      col\n      ...DetailFilterListCategory_category\n    }\n    ... on DetailFilterDropdownCategory {\n      col\n      ...DetailFilterDropdownCategory_category\n    }\n    id\n  }\n  selectioninfo {\n    ...DetailFilterSelectionInfo_selectionInfo\n  }\n}\n\nfragment Documents_component_1W07gZ on Documents {\n  files(salesAdmission: \"AT\") {\n    brochure {\n      ...FileLink_fileLink\n    }\n    factsheet {\n      ...FileLink_fileLink\n    }\n    kid {\n      ...FileLink_fileLink\n    }\n    others {\n      ...FileLink_fileLink\n    }\n  }\n  infolinks {\n    url\n    ...InfoLink_infoLink\n  }\n}\n\nfragment Documents_component_2QtZrJ on Documents {\n  files(salesAdmission: $salesAdmission) {\n    brochure {\n      ...FileLink_fileLink\n    }\n    factsheet {\n      ...FileLink_fileLink\n    }\n    kid {\n      ...FileLink_fileLink\n    }\n    others {\n      ...FileLink_fileLink\n    }\n  }\n  infolinks {\n    url\n    ...InfoLink_infoLink\n  }\n}\n\nfragment FileLink_fileLink on FileLink {\n  header\n  text\n  url\n  date\n  format\n  size\n  smallicon\n  largeicon\n}\n\nfragment FrontPage_page on FrontPage {\n  firstGroup {\n    __typename\n    ...LinkGroup_frontGroup\n    ...LinkListGroup_frontGroup\n  }\n  secondGroup {\n    __typename\n    ...LinkGroup_frontGroup\n    ...LinkListGroup_frontGroup\n  }\n  thirdGroup {\n    __typename\n    ...LinkGroup_frontGroup\n    ...LinkListGroup_frontGroup\n  }\n}\n\nfragment Fund_fund on Funds {\n  fundsname\n  category\n  distribution\n  currency\n  largeinvestmentfonds\n  traits\n  tranches(first: 1000) {\n    edges {\n      node {\n        currency\n        distribution\n        id\n        isin\n        url\n        institutional\n        salesadmission\n      }\n    }\n  }\n}\n\nfragment FundsDetailsPage_page_2QtZrJ on FundsDetailsPage {\n  components(first: 10000) {\n    edges {\n      node {\n        id\n        __typename\n        ...ArchiveList_component\n        ...BaseData_component_2QtZrJ\n        ...PerformanceOverview_component\n        ...PerformanceByYear_component\n        ...FundsIntroduction_component\n        ...TrancheSelection_component\n        ...Widget_component_2xbeJn\n        ... on Widget {\n          components(first: 10000) {\n            edges {\n              node {\n                __typename\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  largeinvestmentfonds\n  reportcurrency\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n  path\n  id\n}\n\nfragment FundsIntroduction_component on FundsIntroduction {\n  title\n  shorttext\n  longtext\n  warning\n}\n\nfragment FundsListDownload_fundsListDownload on SimpleLink {\n  label\n  url\n}\n\nfragment FundsListPage_page_2QtZrJ on FundsListPage {\n  components(first: 1000) {\n    edges {\n      node {\n        __typename\n        ...FundsSelection_component\n        ...Widget_component_2QtZrJ\n        id\n      }\n    }\n  }\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n  path\n  id\n}\n\nfragment FundsManager_component on FundsManager {\n  managername\n  managercompany\n  advisortext\n  picture {\n    ...ProfilePicture_picture\n  }\n  phone\n  email\n}\n\nfragment FundsSelection_component on FundsSelection {\n  title\n  fundstable {\n    ...FundsTable_table\n    id\n  }\n  downloadOverview {\n    ...FundsListDownload_fundsListDownload\n  }\n}\n\nfragment FundsTableHeader_header on FundsTable {\n  tableheader {\n    col\n    label\n  }\n}\n\nfragment FundsTable_table on FundsTable {\n  ...FundsTableHeader_header\n  entries(first: 1000) {\n    edges {\n      node {\n        id\n        fundsname\n        category\n        distribution\n        currency\n        country\n        traits\n        largeinvestmentfonds\n        tranches(first: 1000) {\n          edges {\n            node {\n              url\n              currency\n              distribution\n              id\n              isin\n              institutional\n              salesadmission\n            }\n          }\n        }\n        ...Fund_fund\n      }\n    }\n  }\n  detailfilter {\n    selectioninfo {\n      resultTextSingular\n      resultTextPlural\n    }\n    ...DetailFilter_detailFilter\n    id\n  }\n  livefilter {\n    ...LiveFilter_liveFilter\n  }\n  filterbuttontext\n  filterbuttontextexpanded\n  noResultsMessage\n}\n\nfragment FundsserviceAutocomplete_autocomplete on HomeFundServiceAutocomplete {\n  noResultsMessage\n  furtherResultsMessage\n  items(first: 1000) {\n    edges {\n      node {\n        fundsname\n        country\n        largeinvestmentfonds\n        tranches(first: 1000) {\n          edges {\n            node {\n              url\n              isin\n              salesadmission\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment HomeFundInfoserviceSection_pageSection on HomeFundInfoservice {\n  title\n  titleImageUrl\n  titleImageBackgroundUrl\n  anchorName\n  text\n  loginLink\n  registrationLink\n  loginText\n  registrationText\n}\n\nfragment HomeFundIntroductionSection_pageSection on HomeFundIntroduction {\n  title\n  titleImageUrl\n  titleImageBackgroundUrl\n  anchorName\n  versions {\n    country\n    text\n    subTitle\n    subText\n    quote\n    link1 {\n      ...SimpleLink_simpleLink\n    }\n    link2 {\n      ...SimpleLink_simpleLink\n    }\n  }\n}\n\nfragment HomeFundServiceSection_pageSection on HomeFundService {\n  title\n  titleImageUrl\n  titleImageBackgroundUrl\n  anchorName\n  fundsListUrl\n  text\n  placeholder\n  showAll\n  show\n  autocomplete {\n    items(first: 1000) {\n      edges {\n        node {\n          country\n          fundsname\n          largeinvestmentfonds\n          tranches(first: 1000) {\n            edges {\n              node {\n                url\n                isin\n                salesadmission\n                id\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n    ...FundsserviceAutocomplete_autocomplete\n  }\n}\n\nfragment IconLink_iconLink on IconLink {\n  label\n  iconUrl\n  url\n}\n\nfragment InfoLink_infoLink on InfoLink {\n  header\n  infotext\n  url\n  linktext\n  key\n}\n\nfragment InfoServicePage_page_2QtZrJ on InfoServicePage {\n  salesadmission {\n    ...LabeledSelectBox_labeledSelectBox\n  }\n  retailOnly {\n    ...LabeledSelectBox_labeledSelectBox\n  }\n  components(first: 1000) {\n    edges {\n      node {\n        __typename\n        ...SubscriptionIntroduction_component\n        ...AboManager_component_6AafZ\n        id\n      }\n    }\n  }\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n  path\n  id\n}\n\nfragment ItemListEntry_component on ItemListEntry {\n  id\n  label\n  value\n  info\n  indent\n  valueInfo\n}\n\nfragment ItemList_component on ItemList {\n  id\n  entries(first: 1000) {\n    edges {\n      node {\n        ...ItemListEntry_component\n        id\n      }\n    }\n  }\n  smalllabel\n}\n\nfragment LabeledSelectBox_labeledSelectBox on LabeledSelectBox {\n  label\n  selectbox {\n    ...Selectbox_selectBox\n  }\n}\n\nfragment LanguagePreference_component on LanguagePreference {\n  info {\n    ...CategoryInfo_info\n  }\n  items {\n    label\n    filtervalue\n  }\n  categoryname\n}\n\nfragment LinkGroup_frontGroup on LinkGroup {\n  title\n  links {\n    ...TaglineLink_tagLineLink\n  }\n}\n\nfragment LinkListGroup_frontGroup on LinkListGroup {\n  title\n  linkLists {\n    ...LinkList_linkList\n  }\n}\n\nfragment LinkList_linkList on LinkList {\n  title\n  links {\n    ...IconLink_iconLink\n  }\n}\n\nfragment LinkSection_pageSection on LinkSection {\n  title\n  titleImageUrl\n  titleImageBackgroundUrl\n  anchorName\n  linkSectionText: text\n  links {\n    ...ComplexLink_complexLink\n  }\n}\n\nfragment LiveFilter_liveFilter on LiveFilter {\n  placeholder\n}\n\nfragment LocationBlock_contentBlock on LocationBlock {\n  phoneLabel\n  faxLabel\n  emailLabel\n  address {\n    ...Address_address\n  }\n  coordinates {\n    latitude\n    longitude\n  }\n}\n\nfragment LogoBlock_contentBlock on LogoBlock {\n  logoUrl\n  logoAltText\n  captionTitle\n  captionText\n  isQuote\n}\n\nfragment MarkdownBlock_contentBlock on MarkdownBlock {\n  markdown\n}\n\nfragment OtherDocuments_documentLabels on DocumentLabels {\n  labels {\n    key\n    label\n    shortlabel\n  }\n  documentLabelsTitle\n  furtherDocumentLabelsTitle\n  allDocumentLabelsTitle\n}\n\nfragment OverviewSection_pageSection on OverviewSection {\n  title\n  titleImageUrl\n  titleImageBackgroundUrl\n  anchorName\n  overviewSectionText: text\n  detailPageLink {\n    ...SimpleLink_simpleLink\n  }\n}\n\nfragment PageFooter_siteFooter on SiteInfo {\n  footer {\n    ...SimpleLink_simpleLink\n  }\n}\n\nfragment PageHeader_pageHeader on PageHeader {\n  pageImageUrl\n  pageBackgroundImageUrl\n  smallHeader\n  pageImageOverlayText\n  authLink {\n    ...AuthButton_authLink\n  }\n}\n\nfragment PageHeader_siteInfo on SiteInfo {\n  fundsListUrl\n  rootUrl\n  navigation {\n    ...SimpleLink_simpleLink\n  }\n  searchPageUrl\n}\n\nfragment PageHeader_translations on Translation {\n  language\n  url\n}\n\nfragment PerformanceByYearLineItem_component on PerformanceByYearLineItem {\n  period\n  development\n}\n\nfragment PerformanceByYear_component on PerformanceByYear {\n  performanceTitle: title\n  lineItems {\n    ...PerformanceByYearLineItem_component\n  }\n}\n\nfragment PerformanceOverviewCurrencySelection_currencySelection on SelectBox {\n  ...Selectbox_selectBox\n}\n\nfragment PerformanceOverviewInfo_data on PerformanceOverviewInfo {\n  currentperformancetext\n  currentbenchmarktext\n  paperformancetext\n  pabenchmarktext\n}\n\nfragment PerformanceOverviewMenu_menu on PerformanceOverviewMenu {\n  xlsdownloadtext\n  currencySelectionInfo\n  currencySelectionHeader\n  currencySelectionSaveButtonText\n}\n\nfragment PerformanceOverviewNumbers_data on PerformanceOverviewInfo {\n  currentperformancetext\n  currentbenchmarktext\n  paperformancetext\n  pabenchmarktext\n}\n\nfragment PerformanceOverview_component on PerformanceOverview {\n  id\n  header\n  disclaimer\n  staticDisclaimer\n  info {\n    ...PerformanceOverviewNumbers_data\n    ...PerformanceOverviewInfo_data\n    id\n  }\n  menu {\n    currencySelectionSaveButtonText\n    currencySelectionInfo\n    currencySelectionHeader\n    ...PerformanceOverviewMenu_menu\n    currencySelectBox {\n      ...PerformanceOverviewCurrencySelection_currencySelection\n    }\n  }\n}\n\nfragment PictureBlock_contentBlock on PictureBlock {\n  title\n  url\n  altText\n}\n\nfragment PriceInfo_component on PriceInfo {\n  tableheader {\n    col\n    label\n  }\n  title\n  file {\n    ...FileLink_fileLink\n  }\n  archive {\n    ...SimpleLink_simpleLink\n  }\n  checked\n}\n\nfragment ProfilePicture_picture on ProfilePicture {\n  url\n}\n\nfragment PublicationsPage_page on PublicationsPage {\n  publicationsList {\n    title\n    yearLabel\n    filterButtonText\n    filterButtonTextExpanded\n    noResultsText\n    variousFundsText\n    liveFilter {\n      ...LiveFilter_liveFilter\n    }\n    detailFilter {\n      ...DetailFilter_detailFilter\n      id\n    }\n    documents {\n      id\n      archiveName\n      mimeType\n      fileDate\n      docTypeName\n      documentType\n      documentTitle\n      size\n      fileName\n      deeplinkCode\n      url\n      fundName\n      isins\n    }\n    id\n  }\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n  path\n  id\n}\n\nfragment QuoteBlock_contentBlock on QuoteBlock {\n  text\n  author\n  iconUrl\n}\n\nfragment SearchPage_page_4ES8AM on SearchPage {\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n  id\n  noResultsText\n  path\n  resultsTextSingular\n  resultsTextPlural\n  results(searchString: $searchString) {\n    headline\n    snippet\n    url\n  }\n  title\n}\n\nfragment SectionPage_page on SectionPage {\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n  sections {\n    __typename\n    anchorName\n    navigationTitle\n    titleImageUrl\n    titleImageBackgroundUrl\n    ...LinkSection_pageSection\n    ...OverviewSection_pageSection\n    ...HomeFundIntroductionSection_pageSection\n    ...HomeFundServiceSection_pageSection\n    ...HomeFundInfoserviceSection_pageSection\n    id\n  }\n}\n\nfragment Selectbox_selectBox on SelectBox {\n  options {\n    key\n    label\n    data\n  }\n}\n\nfragment SiblingNavigation_siblingNavigation on SiblingNavigation {\n  links {\n    url\n    ...SimpleLink_simpleLink\n  }\n}\n\nfragment SimpleLink_simpleLink on SimpleLink {\n  label\n  url\n}\n\nfragment SimplePage_page on SimplePage {\n  components(first: 1000) {\n    edges {\n      node {\n        __typename\n        ...ArchiveList_component\n        id\n      }\n    }\n  }\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n  path\n  id\n}\n\nfragment Site_site_2XmeMr on Site {\n  page(path: $path, visitorInfo: $visitorInfo) {\n    id\n    pageTitle\n    header {\n      ...PageHeader_pageHeader\n    }\n    __typename\n    ...FundsDetailsPage_page_2QtZrJ\n    ...FundsListPage_page_2QtZrJ\n    ...InfoServicePage_page_2QtZrJ\n    ...SimplePage_page\n    ...ArchivePage_page_2QtZrJ\n    ...CutOffListPage_page\n    ...FrontPage_page\n    ...ContentPage_page\n    ...SectionPage_page\n    ...ContactPage_page\n    ...SearchPage_page_4ES8AM\n    ...VisitorInfoPage_page\n    ...PublicationsPage_page\n    ...DeniedPage_page\n    translations {\n      language\n      url\n      ...PageHeader_translations\n    }\n  }\n  userCountry\n  siteInfo(path: $path) {\n    ...PageHeader_siteInfo\n    ...PageFooter_siteFooter\n  }\n  specialPage(language: $language, pageId: $specialPageId) {\n    ...VisitorInfoPage_page\n    __typename\n    id\n  }\n}\n\nfragment Site_user on UserContainer {\n  isLoggedIn\n}\n\nfragment SubscriptionIntroduction_component on SubscriptionIntroduction {\n  title\n  longtext\n}\n\nfragment TaglineLink_tagLineLink on TaglineLink {\n  tagline\n  text\n  title\n  url\n}\n\nfragment TextBlock_contentBlock on TextBlock {\n  title\n  text\n}\n\nfragment TrancheSelection_component on TrancheSelection {\n  tranches {\n    ...LabeledSelectBox_labeledSelectBox\n    trancheSelectBox: selectbox {\n      options {\n        key\n        label\n      }\n    }\n  }\n}\n\nfragment VisitorInfoPage_page on VisitorInfoPage {\n  breadcrumbs {\n    ...Breadcrumb_data\n  }\n  confirmLabel\n  country {\n    options {\n      code\n      label\n    }\n    title\n  }\n  visitorType {\n    options {\n      code\n      description\n      label\n    }\n    title\n  }\n  id\n  path\n  disclaimer\n  explanation\n  language\n  name\n  pageTitle\n  rejectedTitle\n  rejectedText\n  rejectedButtonLabel\n  rejectLabel\n}\n\nfragment Widget_component_1W07gZ on Widget {\n  header\n  name\n  components(first: 1000) {\n    edges {\n      node {\n        id\n        __typename\n        ...FundsManager_component\n        ...CompositionChart_component\n        ...ItemList_component\n        ...Documents_component_1W07gZ\n      }\n    }\n  }\n}\n\nfragment Widget_component_2QtZrJ on Widget {\n  header\n  name\n  components(first: 1000) {\n    edges {\n      node {\n        id\n        __typename\n        ...FundsManager_component\n        ...CompositionChart_component\n        ...ItemList_component\n        ...Documents_component_2QtZrJ\n      }\n    }\n  }\n}\n\nfragment Widget_component_2xbeJn on Widget {\n  header\n  name\n  components(first: 10000) {\n    edges {\n      node {\n        id\n        __typename\n        ...FundsManager_component\n        ...CompositionChart_component\n        ...ItemList_component\n        ...Documents_component_2QtZrJ\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6e8d0c212bfbc34623c9e4b5c1129603";

export default node;
